import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const GenericErrorScreen = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "generic-error-screen" */ './generic-error-screen'),
	),
});
